var _path, _rect, _rect2, _rect3, _rect4;
const _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgNoDeals(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 130,
    height: 108,
    viewBox: "0 0 130 108",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M49 0C43.4772 0 39 4.47715 39 10V20C39 25.5228 43.4772 30 49 30H57C51.4772 30 47 25.5228 47 20C47 14.4772 51.4772 10 57 10H72C77.5228 10 82 14.4772 82 20C82 25.5228 77.5228 30 72 30H80C85.5228 30 90 25.5228 90 20V10C90 4.47715 85.5228 0 80 0H49Z",
    fill: "#EAECF0"
  })), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    y: 23,
    width: 130,
    height: 85,
    rx: 20,
    fill: "#D9D9D9"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    y: 15,
    width: 130,
    height: 85,
    rx: 20,
    fill: "#EAECF0"
  })), _rect3 || (_rect3 = /*#__PURE__*/React.createElement("rect", {
    y: 43,
    width: 130,
    height: 14,
    fill: "white"
  })), _rect4 || (_rect4 = /*#__PURE__*/React.createElement("rect", {
    x: 47,
    y: 45,
    width: 35,
    height: 20,
    rx: 10,
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgNoDeals);
export default __webpack_public_path__ + "static/media/no-deals.7ffb4a9ae0c84b7f492f1069d0395551.svg";
export { ForwardRef as ReactComponent };